import store from "../store/configureStore";

export const createName = (taxonomy) => {
  const {
    modelYear,
    model,
    trim,
    creativeAgency,
    strategy,
    retailOfferType,
    creativeUnit,
    extraInfo,
    format,
    country,
    language,
    creativeVersion,
    dimensions,
    creativeDisplay,
    externalId
  } = taxonomy;

  // Build the name from scratch each time to avoid repeated appends when
  // createName is called multiple times during component renders/updates.
  const parts = [
    modelYear,
    model,
    trim,
    creativeAgency,
    strategy,
    retailOfferType,
    creativeUnit,
    extraInfo,
    format,
    country,
    language,
    creativeVersion,
    dimensions,
    creativeDisplay
  ].join("»");

  const prefix = externalId && externalId.length > 0 ? `${externalId}_` : "";

  taxonomy.name = `${prefix}${parts}`;

  return taxonomy;
};

export const calculateWeight = (nextCreative) => {
  let currentState = { ...store.getState().creatives.byId };
  currentState[nextCreative.id] = nextCreative;

  let currentStateArray = Object.values(currentState);

  let totalWeight = 0;

  currentStateArray.map((c) => (totalWeight += c.weight));

  return totalWeight;
};
